import React, { Fragment, Component } from 'react';
import GenericModal from '../../components/modalGeneric'

export default class oldProjectsComponent extends Component {
    constructor(props){
        super(props);
        this.state = { 
            isModalDisplayed: false,
            selectedProjectId: null,
            modalDetails: null
         };
    }
    toggleModal = (item, title) => {
        this.setState({
            isModalDisplayed: true,
            selectedProjectId: item.projectId,
            modalDetails: title
        });
    }
    handleModalClose = (isConfirmed) => {
        this.setState({
            isModalDisplayed: false,
            selectedProjectId: null,
            modalDetails: null
        });
    }
    handleModalConfirm = () => {
        
        var projectId = this.state.selectedProjectId;

        this.setState({
            isModalDisplayed: false,
            selectedProjectId: null,
            modalDetails: null
        });

        if(projectId && projectId.length > 0)
            this.props.handleProjectRefresh(projectId);
    }
    generateTitle = (item) => {
        return `Id: ${item.projectId}\nName: ${item.name}\nGroup: ${item.projectGroup}\nActivityCacheLastUpdated: ${item.activityCacheLastUpdated}\nAllowanceCacheLastUpdated: ${item.allowanceCacheLastUpdated}\nProjectNotesLastUpdated: ${item.projectNotesLastUpdated}\nPurchaseOrdersLastUpdated: ${item.purchaseOrdersLastUpdated}\nProjectLastUpdated: ${item.lastUpdated || 'N/A'}\nPercentComplete: ${item.percentComplete|| 'N/A'}\nStatus: ${item.projectStatus}`;
    }

    renderSection = (title, sectionItems) => {
        var items = sectionItems || [];
        const hasItems = items && items.length > 0;
        var itemClass = "p-2 pointer-cursor";
        return (
            <div>
                {hasItems ? 
                    <div className="card card-body bg-light p-1">
                        <Fragment>
                            <div className="d-flex flex-wrap bd-highlight">
                            <span className={itemClass} key={'oldProject_' + title}><b>{title}</b></span>
                            {
                                items.map((item, key) => {
                                    const title = this.generateTitle(item);
                                    return (
                                        <span className={itemClass} onClick={() => this.toggleModal(item, title)} key={key} title={title} > 
                                            {item.projectId}
                                        </span>
                                    );
                                })
                            }
                            </div>
                        </Fragment>
                    </div>:
                    <div></div>    
                }
            </div>
        )
    }

    render() {
        var items = this.props.items;

        var activitiesSection = this.renderSection('Activities', items.activityProjects);
        var allowancesSection = this.renderSection('Allowances', items.allowanceProjects);
        var notesSection = this.renderSection('Notes', items.noteProjects);
        var posSection = this.renderSection('POs', items.poProjects);
        var projectsSection = this.renderSection('Projects', items.projects);

        return (
            <Fragment>
                {activitiesSection}
                {allowancesSection}
                {notesSection}
                {posSection}
                {projectsSection}
            <GenericModal 
                isDisplayed={this.state.isModalDisplayed} 
                itemId={this.state.selectedProjectId}
                showConfirmButton={true}
                confirmButton="Refresh"
                handleModalConfirm={this.handleModalConfirm}
                handleModalClose={this.handleModalClose}
                message={this.state.modalDetails}
            />
            </Fragment>
        );
    }
}